import React from 'react';
import './CharlesTitle.scss';
import PropTypes from "prop-types";

function CharlesTitle(props) {
	return (
		<h1 className={`CharlesTitle ${props.alt ? 'alt' : ''}`}>
			<span>
				{props.children}
			</span>
		</h1>
	);
}

CharlesTitle.propTypes = {
	children: PropTypes.string,
	alt: PropTypes.bool,
};

export default CharlesTitle;
